import { Div, createEmitter } from '@codesuma/baseline'
import listsService, { PendingInvite } from '../../services/lists'
import style from './index.module.css'

// Overlay shown on app open when someone has shared a list with you. Accept to
// join the list, ignore to discard the request. Append `.el` to document.body
// and call `.show(invites)`; emits 'accepted' when a list is joined.
export const InvitePrompt = () => {
    const emitter = createEmitter()

    const overlay = Div()
    overlay.addClass(style.overlay)

    const panel = Div()
    panel.addClass(style.panel)

    const title = Div('Shared with you')
    title.addClass(style.title)

    const listEl = Div()
    listEl.addClass(style.list)

    panel.append(title, listEl)
    overlay.append(panel)

    const close = () => {
        if (overlay.el.parentNode) overlay.el.parentNode.removeChild(overlay.el)
        emitter.emit('close')
    }

    const render = (invites: PendingInvite[]) => {
        listEl.empty()
        if (!invites.length) {
            close()
            return
        }

        invites.forEach(invite => {
            const row = Div()
            row.addClass(style.row)

            // Plain text only — inviter name / list name are user-controlled.
            const who = invite.inviter_name && invite.inviter_handle
                ? `${invite.inviter_name} (${invite.inviter_handle})`
                : invite.inviter_name || invite.inviter_handle || 'Someone'

            const text = Div(`${who} shared "${invite.list_name || 'a list'}" with you`)
            text.addClass(style.text)

            const actions = Div()
            actions.addClass(style.actions)

            const reject = Div('Ignore')
            reject.addClass(style.reject)
            const accept = Div('Accept')
            accept.addClass(style.accept)

            const respond = async (ok: boolean) => {
                accept.style({ pointerEvents: 'none' })
                reject.style({ pointerEvents: 'none' })
                try {
                    await listsService.respondToInvite(invite.id, ok)
                    if (ok) emitter.emit('accepted')
                } catch (err) {
                    console.error('Failed to respond to invite:', err)
                }
                render(invites.filter(i => i.id !== invite.id))
            }

            accept.el.onclick = () => respond(true)
            reject.el.onclick = () => respond(false)

            actions.append(reject, accept)
            row.append(text, actions)
            listEl.append(row)
        })
    }

    overlay.el.onclick = (e: MouseEvent) => {
        if (e.target === overlay.el) close()
    }

    const show = (invites: PendingInvite[]) => render(invites)

    return Object.assign(overlay, {
        on: emitter.on.bind(emitter),
        show,
    })
}
